<div class="verification-flow">

    <HomeNavBar/>


    <div class="container py-4">
      <div class="mb-4 step-indicator">
        <div class="row justify-content-center">
          <div class="col-auto" v-for="(step, index) in steps" :key="index">
            <div class="step d-flex flex-column align-items-center" :class="{ active: currentStepIndex === index, completed: currentStepIndex > index }">
              <div class="step-circle" :class="currentStepIndex === index ? 'bg-danger text-white border-danger' : currentStepIndex > index ? 'bg-success text-white border-success' : 'bg-light text-secondary border border-2'">{{ index + 1 }}</div>
              <div class="step-label" :class="currentStepIndex === index ? 'text-danger fw-bold' : currentStepIndex > index ? 'text-success' : 'text-secondary'">{{ step.label }}</div>
            </div>
          </div>
        </div>
      </div>


      <div v-if="currentStepIndex === 0" class="step-content bg-white shadow p-4 p-md-5 rounded">
        <h2 class="text-center text-danger mb-4">Choose Your Membership Plan</h2>
        <div class="row g-3 mb-2">
  <div class="col-md-4 d-flex align-items-stretch" v-for="(plan, index) in membershipPlans" :key="plan.id">
    <div class="w-100 d-flex flex-column align-items-center">
      <span v-if="current_membership && plan.id === current_membership.id" class="badge bg-success fs-6 px-4 py-2 mb-2" style="border-radius: 1rem 1rem 0 0;">Current Plan</span>
      <div
        class="membership-card border rounded-3 p-4 d-flex flex-column h-100 w-100"
        :class="[
          current_membership && plan.id === current_membership.id ? 'border-success border-3 shadow-lg bg-light position-relative' : 'border-2',
          selectedPlan === index && !(current_membership && plan.id === current_membership.id) ? 'selected' : ''
        ]"
        @click="selectPlan(index)"
        style="transition: box-shadow 0.3s, border-color 0.3s, transform 0.2s; min-height: 420px;"
      >
        <h3 class="text-center fw-bold" :class="{ 'text-success': current_membership && plan.id === current_membership.id }">{{ plan.name }}</h3>
        <div class="membership-price text-center fs-4 fw-semibold mb-2" :class="{ 'text-success': current_membership && plan.id === current_membership.id }">
          {{ (plan.membership_pricing || []).length > 0 ? 'R' + parseFloat(plan.membership_pricing[0].price).toFixed(2) : 'N/A' }}
        </div>
        <div class="membership-period text-center mb-4 text-muted">{{ plan.billing_cycle?.name || '-' }}</div>
        <ul class="membership-features list-unstyled mb-4 flex-grow-1">
          <li v-for="(feature, i) in plan.membership_perks" :key="i" class="py-2 border-bottom">
            {{ feature.perk.name }}
          </li>
        </ul>
        <div class="mt-auto text-center pt-3">
          <button v-if="current_membership && plan.id === current_membership.id" class="btn btn-success text-white px-4 py-2 rounded-pill fw-bold shadow-sm" disabled>Current</button>
          <button v-else class="btn px-4 py-2 rounded-pill fw-bold" :class="selectedPlan === index ? 'btn-danger text-white' : 'btn-light'">
            {{ selectedPlan === index ? 'Selected' : 'Select' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

        <div class="d-flex justify-content-between">
          <button class="btn btn-outline-secondary rounded-pill px-4" @click="cancel">Cancel</button>
          <button class="btn btn-danger rounded-pill px-4"
  :disabled="selectedPlan === null || (current_membership && membershipPlans[selectedPlan]?.id === current_membership.id)"
  @click="nextStep">
  Continue
</button>
        </div>
      </div>


      <div v-if="currentStepIndex === 1" class="step-content bg-white shadow p-4 p-md-5 rounded">
        <h2 class="text-center text-danger mb-4">Payment Information</h2>

        <div v-if="selectedPlan !== null" class="bg-light p-4 rounded mb-4">
          <h3 class="position-relative pb-3 mb-4">Order Summary
            <span class="position-absolute bottom-0 start-0 bg-danger" style="height: 3px; width: 60px;"></span>
          </h3>
          <div class="d-flex justify-content-between py-3 border-bottom">
            <span>{{ membershipPlans[selectedPlan].name }} Plan ({{ membershipPlans[selectedPlan].billing_cycle.name }})</span>
            <span>R{{ membershipPlans[selectedPlan].membership_pricing[0].price }}</span>
          </div>
          <div class="d-flex justify-content-between pt-4 mt-2 fw-bold fs-5 text-danger">
            <span>Total</span>
            <span>R{{ membershipPlans[selectedPlan].membership_pricing[0].price }}</span>
          </div>
        </div>
        <div class="d-flex flex-column flex-md-row justify-content-between">
          <button class="btn btn-outline-secondary rounded-pill px-4 mb-3 mb-md-0" @click="prevStep">Back</button>

          <div>
            <button class="btn btn-primary rounded-pill px-4 me-2" @click="completePayment">Subscribe</button>

          </div>
        </div>


        <form id="payment_form" :action="payfast" method="POST" class="d-none">
          <input type="submit" value="Submit" />
        </form>
        <!-- Input clone (hidden template) -->
        <input type="hidden" id="input_clone" class="d-none" />
      </div>
    </div>
  </div>